// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container-dz[data-v-b91544b6] {\n  max-height: 500px;\n  overflow: auto;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
